import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=b15af37e&"
import script from "./MetricCard.vue?vue&type=script&lang=js&"
export * from "./MetricCard.vue?vue&type=script&lang=js&"
import style0 from "./MetricCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports